import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { Box, Text } from 'components/Wrapped';
import styled from 'styled-components';
import { colorStyle } from 'grommet-styles';
import { useSelector } from 'react-redux';

const NavLinkWrapper = styled(NavLink)`
  color: #B4B6B7;
  margin-bottom: 5px;
  padding: 1em 1.5em;
  font-weight: 600;
  /* background-color: var(--background-3); */
  border-radius: 10px;

  &:hover,
  &.is-active {
    ${(props) => colorStyle('background', 'rgba(255, 255, 255, 0.1)', props.theme)}
  }
  &.is-active {
    ${(props) => colorStyle('border-color', 'primary', props.theme)}
    ${(props) => colorStyle('background', '#FFFFFF1A', props.theme)}
    ${(props) => colorStyle('color', 'white', props.theme)}
    ${'' /* border-left-width: 5px;
    border-left-style: solid; */}
  }
`;

const WrappedSideMenu = ({ menuItems }) => {
  const profile = useSelector((state) => state.user.profile);

  return (
    <Box as="ul" pad={{ right: '20px' }}>
      <Box gap="8px" pad={{ bottom: '15px' }}>
        <Box align="center" direction="row" gap="10px" pad={{ horizontal: '12px', vertical: '14px' }}>
          <Box pad="none">
            <Text weight={600} style={{ lineHeight: '17px', wordBreak: 'break-word' }}>
              {profile?.email}
            </Text>
            <Text color="#B4B6B7" weight={500} style={{ lineHeight: '17px' }}>
              UID: {profile?.customerID}
            </Text>
          </Box>
        </Box>
      </Box>
      {menuItems.map(({ children, to, exact, activeEvent }) => (
        <Box as="li" pad="none" key={to} round="10px">
          <NavLinkWrapper to={to} exact={exact} activeClassName="is-active" isActive={activeEvent}>
            {children}
          </NavLinkWrapper>
        </Box>
      ))}
    </Box>
  );
};

WrappedSideMenu.propTypes = {
  menuItems: PropTypes.array.isRequired,
  children: PropTypes.node,
};

export default WrappedSideMenu;
